import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { History } from 'lucide-react';
import WorkspaceLayout from '../../../layout/WorkspaceLayout';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import FiscalTabs from '../../../components/FiscalEvents/FiscalTabs';
import PurchaseReturnDocumentSelector from '../../../components/FiscalEvents/PurchaseReturnDocumentSelector';
import PurchaseReturnEventWizard from '../../../components/FiscalEvents/PurchaseReturnEventWizard';
import FiscalEventService from '../../../services/fiscal/FiscalEventService';
import { FiscalEvent } from '../../../types/fiscal/FiscalEvent';
import { PurchaseReturnDocumentCandidate } from '../../../types/fiscal/PurchaseReturnEvent';
import FiscalEventsList from '../../../components/FiscalEvents/FiscalEventsList';
import FiscalEventDetailModal from '../../../components/FiscalEvents/FiscalEventDetailModal';
import useAlerts from '../../../hooks/useAlerts';

export default function PurchaseReturnEventsPage() {
  const { purchaseId } = useParams<{ purchaseId?: string }>();
  const navigate = useNavigate();
  const parsedPurchaseId = purchaseId ? Number(purchaseId) : undefined;

  const [tab, setTab] = useState(0);
  const [selectedDocument, setSelectedDocument] = useState<PurchaseReturnDocumentCandidate>();
  const [events, setEvents] = useState<FiscalEvent[]>([]);
  const [detail, setDetail] = useState<FiscalEvent | null>(null);
  const [loading, setLoading] = useState(false);
  const { show } = useAlerts();

  const searchEvents = async (candidate: PurchaseReturnDocumentCandidate) => {
    setSelectedDocument(candidate); setLoading(true);
    try { setEvents((await FiscalEventService.findByPurchase(candidate.purchaseId)).filter((event) => event.eventType === 'RETURN')); }
    catch (error: any) { show('error', error?.response?.data?.title || 'Consulta fallida', error?.response?.data?.message || 'No se pudieron consultar los eventos.'); }
    finally { setLoading(false); }
  };

  return <WorkspaceLayout><BreadcrumbTwo /><main className="space-y-5 rounded-xl border border-stroke bg-white p-4 shadow-default dark:border-strokedark dark:bg-boxdark sm:p-6">
    <header><h1 className="text-xl font-semibold text-black dark:text-white">Eventos de Retorno de Compras</h1><p className="mt-1 text-sm text-body">Seleccione compras de Sujeto Excluido; la elegibilidad, los saldos y las reglas se validan en el backend.</p></header>
    <FiscalTabs ariaLabel="Secciones de eventos de retorno de compras" tabs={[{ label: 'Nuevo Retorno' }, { label: 'Eventos generados', count: events.length }]} activeIndex={tab} onChange={setTab} />
    {tab === 0
      ? <PurchaseReturnEventWizard
          embedded
          isOpen
          initialPurchaseId={parsedPurchaseId}
          onClose={() => { if (parsedPurchaseId) navigate('/purchases/returns'); }}
          onCreated={() => { setTab(1); if (parsedPurchaseId) navigate('/purchases/returns'); }}
        />
      : <section className="space-y-5"><div className="rounded-xl border border-stroke p-4 dark:border-strokedark"><div className="mb-4 flex items-center gap-2"><History className="h-5 w-5 text-primary" /><h2 className="font-semibold text-black dark:text-white">Consultar eventos por documento</h2></div><PurchaseReturnDocumentSelector mode="single" selected={selectedDocument ? [selectedDocument] : []} onSelect={searchEvents} disabled={loading} /></div>{selectedDocument && <div className="rounded-xl bg-gray-2 p-4 text-sm dark:bg-meta-4"><span className="font-medium text-black dark:text-white">Documento: {selectedDocument.documentNumber}</span><span className="ml-3 text-body">{selectedDocument.generationCode}</span></div>}<FiscalEventsList events={events} onOpen={setDetail} /></section>}
  </main><FiscalEventDetailModal event={detail} onClose={() => setDetail(null)} /></WorkspaceLayout>;
}
